import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { SWRConfig } from "swr"
import { TooltipProvider } from "@/components/ui/tooltip"
import { AuthProvider } from "@/contexts/AuthContext"
import { App } from "@/App"
import "@/index.css"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SWRConfig value={{ refreshInterval: 120_000, revalidateOnFocus: false }}>
        <TooltipProvider delayDuration={300}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </TooltipProvider>
      </SWRConfig>
    </BrowserRouter>
  </React.StrictMode>
)
